<template>
  <!-- Error page-->
  <div>
    <!-- <b-row class="m-5">
      <b-col cols="4">
        <Select3 />
      </b-col>
    </b-row> -->
    <div class="misc-wrapper">
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">Admin</h2>
      </b-link>

      <div class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
          <h2 class="mb-1">Page Not Found 🕵🏻‍♀️</h2>
          <p class="mb-2">
            Oops! 😖 The requested URL was not found on this server.
          </p>

          <b-button
            variant="primary"
            class="mb-2 btn-sm-block"
            :to="{ path: '/' }"
          >
            Back to home
          </b-button>

          <!-- image -->
          <component :is="downImg" />
        </div>
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import store from "@/store/index";
import ClickOutside from "vue-click-outside";
import error from "@/assets/images/pages/error.svg";
import errorDark from "@/assets/images/pages/error-dark.svg";

export default {
  components: {
    VuexyLogo,
    BLink,
    BButton,
    BImg,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      error,
      errorDark,
      downImg: require("@/assets/images/pages/error.svg"),
      showDrop: false,
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties

        return this.error;
      }
      return this.errorDark;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-misc.scss";
</style>
